import React, { FC } from 'react'
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Link, RouteComponentProps } from 'react-router-dom'
import { onDemandCategories } from '../categories'
import { setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import IframeModal from '../../GlobalModals/IframeModal'
import routes from 'src/routes'

export const CategorySelection: FC<RouteComponentProps> = () => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const [playVideo, setPlayVideo] = useState({})

  useEffect(() => {
    dispatch(setPageTitle('Gallery'))
    dispatch(setPreviousPage(routes.lobby))
  }, [dispatch])

  const onClick = (item) => {
    if (item.type === 'additional') {
      window.open(item.destination)
    } else {
      setIsOpen(true)
      setPlayVideo({
        title: 'Video',
        link: item.destination,
      })
    }
  }

  return (
    <>
      <div className="grid-container">
        {onDemandCategories.map((item) => {
          return (
            <>
              {item.type === 'additional' || item.type === 'video' ? (
                <div key={item.id} onClick={() => onClick(item)} className="card-thumbnail">
                  <img src={item.thumbnail} width="100%" alt="thumbnail" />
                </div>
              ) : (
                <Link key={item.id} to={item.destination} className="card-thumbnail" target={item.type === 'pdf' ? '_blank' : ''}>
                  <img src={item.thumbnail} width="100%" alt="thumbnail" />
                </Link>
              )}
            </>
          )
        })}
      </div>
      {isOpen && <IframeModal iframeOpen={isOpen} setIframeOpen={setIsOpen} iframe={playVideo} />}
    </>
  )
}
